<script lang="ts">
  import NavigationButtons from './Buttons.svelte'
</script>

<div class="topbar">
  <div class="left">
    <slot name="left">
      <NavigationButtons />
    </slot>
  </div>
</div>

<div class="spacer" />

<style>
  .topbar {
    display: flex;
    overflow: hidden;
    background-color: var(--tsf-black);
    color: var(--tsf-washed-grey);
    position: fixed;
    top: 0;
    min-width: 100vw;
    width: 100%;
    min-height: 5em;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
  }

  .left {
    float: left;
    padding-left: 1em;
  }

  .spacer {
    height: 5em;
  }
</style>
